export const getDictionarySelectProps = (overrides = {}) => ({
  optionValue: 'Code',
  optionLabel: 'Description',
  showLabelOnly: false,
  ...overrides,
});
